<template>
  <v-app id="private_app">
    <Navigation/>
    <v-app-bar
        flat
        color="white"
        elevation="1"
        app
        :clipped-left="$vuetify.breakpoint.lgAndUp"
    >
      <v-app-bar-nav-icon @click="projectsDrawer"/>
      <v-img
          src="@/assets/img/logo.png"
          max-width="120"
          style="margin-right: 95px"
      ></v-img>
      <v-text-field
          flat
          solo
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="Поиск тикетов"
          class="hidden-sm-and-down"
          background-color="rgba(0, 0, 0, 0.06)"
          color="primary"
          v-model="search"
          v-on:keyup.enter="startSearch"
      >
        <template v-slot:append>
          <v-menu
              bottom
              left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  small
                  text
                  v-bind="attrs"
                  v-on="on"
              >
                {{ !target ? 'По сообщениям' : 'По номеру запроса' }} <v-icon right small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="target = 0">
                <v-list-item-content>
                  <v-list-item-title>По сообщениям</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="target = 1">
                <v-list-item-content>
                  <v-list-item-title>По номеру запроса</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-text-field>
      <v-spacer/>
      <v-menu
          v-model="menu"
          bottom
          right
          transition="scale-transition"
          origin="top right"
      >
        <template v-slot:activator="{ on }">
          <v-chip
              v-on="on"
              large
              pill
              color="transparent"
          >
            <v-avatar left>
              <v-img v-if="$store.state.user.company.logo !== 'no'"
                     :src="$store.state.user.company.logo"
              />
              <v-icon v-else color="primary">mdi-account-circle</v-icon>
            </v-avatar>
            {{ $store.state.user.name }}
          </v-chip>
        </template>
        <v-card width="300">
          <v-list dark color="primary">
            <v-list-item>
              <v-list-item-avatar>
                <v-img v-if="$store.state.user.company.logo !== 'no'"
                       :src="$store.state.user.company.logo"
                />
                <v-icon x-large v-else color="white">mdi-account-circle</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $store.state.user.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ $store.state.user.company.name }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                    icon
                    @click="menu = false"
                >
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list>
            <v-list-item :to="{name: 'account_password'}">
              <v-list-item-action>
                <v-icon>mdi-lock-outline</v-icon>
              </v-list-item-action>
              <v-list-item-title>Смена пароля</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$store.dispatch('logout');">
              <v-list-item-action>
                <v-icon color="red">mdi-exit-to-app</v-icon>
              </v-list-item-action>
              <v-list-item-title class="red--text">Выход</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>
    <router-view class="fill-height concrete" />
  </v-app>
</template>

<script>
export default {
  name: 'Private',
  components: {
    Navigation: ()  => import('@/components/bar/Navigation.vue'),
  },
  data: () => ({
    menu: false,
    search: '',
    target: 1
  }),
  methods: {
    startSearch() {
      if (this.search.length >= 3 || this.target) {
        this.$router.push({ name: 'search', query: { key: this.search, target: this.target } })
      } else {
        this.$store.commit('setSnack', {
          status: true,
          code: 400,
          message: "Минимальное количество символов для поиска - 3",
          type: 'error'
        });
      }
    },
    projectsDrawer() {
      let status = this.$store.state.drawer ? false : true;
      this.$store.commit('drawerEnable', status);
    }
  }
}
</script>

<style>

</style>